import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import changeLogService from "services/change-log-service";
import CrudService from "services/cruds-service";

// MUI & Material Dashboard components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

// E4A Components
import TimelineList from "e4acomponents/Timeline/TimelineList";
import TimelineItem from "e4acomponents/Timeline/TimelineItem";
import MDTypography from "components/MDTypography";

import SnapshotDialog from "../snapshot-dialog";

function HistoryTab({
    partCode
}) {
    const { id } = useParams();
    const [timelineData, setTimelineData] = useState([]);
    const [showChangeLog, setShowChangeLog] = useState(false);
    const [openSnapshotDialog, setOpenSnapshotDialog] = useState(false);
    const [snapshotRevNum, setSnapshotRevNum] = useState(null);

    // Fetches the partcode's change logs
    useEffect(() => {
        (async () => {
            const response = await changeLogService.getPartCodeChangeLog(id);
            if (response.data.attributes) {
                setTimelineData(formatChangeLogs([...response.data.attributes].reverse()));
                setShowChangeLog(true);
            }
        })();
    }, []);

    // Facilitates the assocation of the timeline data with the correct icons
    const associatedIcon = {
        "approved": ["check", "success"],
        "rejected": ["close", "error"],
        "created": ["add", "secondary"],
        "updated": ["update", "info"],
        "edit": ["edit", "info"],
        "added to bom": ["link", "primary"],
        "removed from bom": ["linkoff", "warning"],
        "image change": ["image", "info"],
        "attachments change": ["attach_file", "info"],
        "up revision": ["arrow_upward", "success"],
        "archived": ["archive", "dark"],
        "restored": ["unarchive", "dark"],
        "disabled": ["block", "dark"],
        "enabled": ["check_circle", "dark"],
        "deleted": ["delete", "error"],
        "obsolete": ["history_toggle_off", "dark"],
        "reinstated" : ["history_toggle_on", "dark"],
    }

    // Formats the changeLogs into timeline data
    const formatChangeLogs = (changeLogs) => {
        return changeLogs.map((changeLog, index) => {
            const color = associatedIcon[changeLog.type.toLowerCase()][1];
            const icon = associatedIcon[changeLog.type.toLowerCase()][0];
            const title = changeLog.type;
            const dateTime = new Date(changeLog.created_at).toLocaleString();
            const description = formatDescription(changeLog);;
            const lastItem = index === changeLogs.length - 1;
            const revNum = changeLog?.revNum || null;
            if (changeLog.comment) {
                const comment = changeLog.comment;
                return { color, icon, title, dateTime, description, comment, lastItem, revNum };
            } else {
                return { color, icon, title, dateTime, description, lastItem, revNum };
            }
        });
    }

    // Formats the description field for timeline items
    const formatDescription = (changeLog) => {
        return `${changeLog.description} by ${changeLog.user.name}`;
    }
    // Handles opening and closing of snapshot dialog
    const handleOpenSnapshotDialog = (revNum) => {
        console.log("Opening shanpshot dialog for revision number:", revNum);
        setSnapshotRevNum(revNum);
        setOpenSnapshotDialog(true);
    }
    // Closes the snapshot dialog
    const handleCloseSnapshotDialog = () => {
        setOpenSnapshotDialog(false);
    }
    // Renders the timeline items
    const renderTimelineItems = timelineData.map(
        ({ color, icon, title, dateTime, description, comment, lastItem, revNum }) => (

            <TimelineItem
                key={title + color}
                color={color}
                icon={icon}
                title={title}
                dateTime={dateTime}
                description={description}
                comment={comment}
                lastItem={lastItem}
                {...(title === "Up Revision" && {
                    onOpenSnapshot: () => handleOpenSnapshotDialog(revNum),
                })}
            />
        )
    );

    return (
        <MDBox>
            <SnapshotDialog
                open={openSnapshotDialog}
                uniqueNum={partCode?.unique_num}
                partCategoryId={partCode?.partCategory?._id}
                revNum={snapshotRevNum}
                onClose={handleCloseSnapshotDialog}
            />
            <MDBox mt={{ xs: 4, md: 10 }} mb={{ xs: 4, md: 8 }}>

                {showChangeLog ? (
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={10} md={8}>
                            <Card>
                                <TimelineList title="Change Logs : ">{renderTimelineItems}</TimelineList>
                            </Card>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container justifyContent="center">
                        <Grid item xs={12} sm={10} md={8}>
                            <Card>
                                <MDTypography variant="h6" textAlign="center" p={2}>
                                    No change logs available
                                </MDTypography>
                            </Card>
                        </Grid>
                    </Grid>
                )}
            </MDBox>
        </MDBox>
    )
}
export default HistoryTab;